import React, { useEffect, useState } from 'react';
import { useCore } from 'contexts/core';
import LoadingSpinner from '../../ui/LoadingSpinner/LoadingSpinner';
import styled from 'styled-components';

type Props = {
  sidebarWidthRems: number;
};

const SpinnerContainer = styled.div<{ rightRems: number }>`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: ${props => props.rightRems}rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.8);
`;

const SceneLoadingScreen = ({ sidebarWidthRems }: Props) => {
  const core = useCore();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    let timer: number;

    const onLoading = () => {
      if (timer) clearTimeout(timer);
      timer = window?.setTimeout(() => {
        setLoading(true);
      }, 150);
    };

    const onLoaded = () => {
      if (timer) clearTimeout(timer);
      setLoading(false);
    };
    const unsubscribers = [
      core.subscribe('loadVpc', onLoading),
      core.subscribe('solutionUpdateInProgress', onLoading),
      core.subscribe('modelLoaded', onLoaded),
      core.subscribe('loadVpcFailure', onLoaded),
      core.subscribe('solutionUpdateDone', onLoaded)
    ];
    return () => {
      unsubscribers.forEach(unsubscribe => {
        unsubscribe();
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [core, loading]);

  if (!loading) {
    return null;
  }

  return (
    <SpinnerContainer id="loading-indicator" rightRems={sidebarWidthRems}>
      <LoadingSpinner />
    </SpinnerContainer>
  );
};

export default SceneLoadingScreen;
